import { render, staticRenderFns } from "./TabTripDetails.vue?vue&type=template&id=1b3e0655&"
import script from "./TabTripDetails.vue?vue&type=script&lang=js&"
export * from "./TabTripDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports